import { Box, styled } from '@mui/material';

export const StyledToTopButton = styled(Box, {
  shouldForwardProp: prop => prop !== 'show',
})(({ show }: { show: boolean }) => ({
  width: '66px',
  height: '66px',
  borderRadius: '50%',
  padding: 0,
  cursor: 'pointer',
  position: 'fixed',
  bottom: 140,
  right: 50,
  scale: show ? 1 : 0,
  transition: 'scale 0.3s ease-in-out',
}));
